import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import Select from "react-select";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
// const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
// const hours = currentDate.getUTCHours();
// const minutes = currentDate.getUTCMinutes();

const RepotsManufacturer = (props) => {
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  // const [hiddenColumns, setHiddenColumns] = useState([]);
  // const [totalRows, setTotalRows] = useState(0);
  // const [deliveryemployeeDropdown, setDeliveryemployeeDropdown] = useState([]);
  // const [selectedEmployee, setSelectedEmployee] = useState(0);
  // const [employeeOptions, setEmployeeOptions] = useState([]);


  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    SubTotalSum: 0,
    TaxSum: 0,
    CostOfGoodsSoldSum: 0,
    ProfitSum: 0,
  });

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
  };

  const paramObject = useParams();

  console.log(responseData, "responseData127");

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        setLoading(false);
        return res;
      });

    //   axios
    //   .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
    //     headers: {
    //       "Content-Type": "application/json;charset=UTF-8",
    //       Authorization: token,
    //     },
    //   })
    //   .then((res) => {
    //     setDeliveryemployeeDropdown(res.data.ResponseData);
    //     setLoading(false);
    //     return res;
    //   });


      

  }, []);

  //Function for export excel

  // to calculate the total

  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };
  const RolesDropdown = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "RolesDropdown");
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );
  console.log(reportdropdown, "reportdropdown");

  // let employeeOptions = [];
  // const employeeDropDownData = deliveryemployeeDropdown.map((u, i) => {
  //   employeeOptions[i] = {
  //     label: u.Name,
  //     value: u.Id,
  //   };
  // });

  // console.log(employeeOptions, "employeeOptions");

  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const token = 'yourAuthToken'; // Replace with your authentication token
  //     const response = await axios.get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
  //       headers: {
  //         'Content-Type': 'application/json;charset=UTF-8',
  //         Authorization: token,
  //       },
  //     });
  //     setDeliveryemployeeDropdown(response.data.ResponseData);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     setLoading(false);
  //   }
  // };

  // const HandleDropdownChange = async (selectedEmployee) => {
  //   console.log(selectedEmployee , "selectedEmployee")
  //   setSelectedEmployee(selectedEmployee.value ); // Set the selected option to state
  // };010

  // useEffect(() => {
  //   setEmployeeOptions(
  //     deliveryemployeeDropdown.map((u) => ({
  //       label: u.Name,
  //       value: u.Id,
  //     }))
  //   );
  // }, [deliveryemployeeDropdown]);
  


  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

 
  const columns = useMemo(() => [
    {
      header : "Manufacturer",
      accessorKey : "manufacturers",
      filterFn: "contains",
    },
    {
      header : "Sub Total",
      accessorKey : "Subtotal",
      filterFn: "contains",
    },
    {
      header : "Total",
      accessorKey : "Total",
      filterFn: "contains",
    },
    {
      header : "Tax",
      accessorKey : "Tax",
      filterFn: "contains",
    },
    {
      header : "Profit",
      accessorKey : "Profit",
      filterFn: "contains",
    },
    // {
    //   header : "Item Variation",
    //   accessorKey : "ItemVariation",
    // },
    {
      header : "Number Of Items Sold",
      accessorKey : "NumberOfItemSoldint",
      filterFn: "contains",
    },
  ]);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `RepotsManufacturer_.xlsx`);
  };
  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const apicall = () => {
  //   // const fetchData = async () => {
  //   const columnIndex = columns.findIndex(
  //     (column) => column.accessorKey === sorting[0]?.id
  //   );
  //   console.log(
  //     JSON.stringify(columnFilters) + " columnFilters | ",
  //     globalFilter + " globalFilter | ",
  //     pagination.pageIndex + " pagination.pageIndex | ",
  //     pagination.pageSize + " pagination.pageSize | ",
  //     columnIndex,
  //     sorting[0]?.id,
  //     sorting[0]?.desc === undefined
  //       ? "desc"
  //       : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
  //     startdate + " startdate | ",
  //     enddate + " enddate",
  //     "api Call payload"
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters;

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/RepotsManufacturer?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         setData(res.data.ResponseData);
  //         setRowCount(res.data.ResponseData[0].TotalRecord);
  //         //   barcodeRefs.current = responseData;
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  //   // }
  //   // fetchData();
  // };

  useEffect(() => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/repotsmanufacturers?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) =>({
            ...el,
            manufacturers : String(el.manufacturers),
            Profit : Number(el.Profit)
          }))
          setResponseData(FilterData);
          setData(FilterData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
          setTotalData({
            ...totalData,
            TotalSum : res.data.ResponseData[0].TotalSum,
            SubTotalSum : res.data.ResponseData[0].SubTotalSum,
            TaxSum : res.data.ResponseData[0].TaxSum,
            CostOfGoodsSoldSum : res.data.ResponseData[0].CostOfGoodsSoldSum,
            ProfitSum : res.data.ResponseData[0].ProfitSum,
          });
        }else{
          setRowCount(0);
          setTotalData({
            ...totalData,
            TotalSum : 0,
            SubTotalSum : 0,
            TaxSum : 0,
            CostOfGoodsSoldSum : 0,
            ProfitSum : 0,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,

  ]);

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Manufacturer_Report_xlsx`);
  };
  console.log(selectReport == 2);
  // Handle Download-
  const downloadPDF = (rows, field, visibleColumns) => {
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = "Sonar POS";
    let reportHeading = "Manufacturer Report ";
    let reportDateHeading =
      startdate && enddate ? `From: ${startdate} To: ${enddate}` : "All Date";
  
    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );
  
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData.map((el) => {
        return {
          ...el,
          OpenBalance:
            el.OpenBalance == null || el.OpenBalance === "NaN" ? "" : parseFloat(el.OpenBalance),
          ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
          DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
        };
      });
    }
  
    const doc = new jsPDF("p", "mm", "a4");
  
    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;
  
    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);
  
    doc.setFontSize(10);
  
    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);
  
      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];
  
      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);
  
      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;
  
      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed
  
      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";
  
            if (typeof dataValue === 'number') {
              value = parseFloat(dataValue);
            } else if (typeof dataValue === 'string') {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("YYYY-MM-DD HH:mm");
            }
  
            return value;
          });
  
          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };
  
      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      doc.text(reportMainHeading, centerX, 10);
  
      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      doc.text(reportHeading, centerXHeading, 15);
  
      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 20);
  
      doc.setPage(currentPage);
      doc.autoTable(content);
  
      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }
  
    doc.save("Report_Manufacturer.pdf");
  };
  
  

  console.log(reportdropdown, "reportdropdown");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">RepotsManufacturer</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Manufacturer</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>

            {/* <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
              Delivery Emp
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={employeeOptions}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    // value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      HandleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>  */}
            
            {/* <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
              Status
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={employeeOptions}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    // value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      HandleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>  */}


            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div
            className="row"
            style={{
              display: "grid",
              gap: "1rem",
              // gridTemplateColumns: "repeat(5,1fr)"
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            }}
          >
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.SubTotalSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Subtotal</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.TotalSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Total</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.TaxSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Tax</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.ProfitSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Profit</p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.CostOfGoodsSoldSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Cost Of Goods Sold Sum</p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>


            {/* <div className="col-sm-2 align-self-sm-end">
            <button
              type="submit"
              className="btn btn-primary pull-right"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div> */}
          </div>

          



          {/* Receipt */}

          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="P">Sonar Pos</h6>
                  <p className="fw-bold p-regular">Manufacturer</p>
                  <div className="row">
                    <p>
                      Date: {startdate} to {enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div className="button mb-2">
                <button
                  onClick={onBtExport}
                  className="btn btn-sm btn-outline-dark  "
                // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-excel me-2 lg"></i>
                  Export to Excel
                </button>
                <button
                  onClick={downloadPDF}
                  className="btn btn-sm btn-outline-dark  m-1"
                // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-export me-2 lg"></i>
                  Export to Pdf
                </button>
                <button
                  className="btn btn-sm btn-outline-dark  m-1"
                  onClick={onBtPrint}
                >
                   <i class="fas fa-print me-2 lg"></i>
                  Print
                </button>
              </div> */}

              {/* <div className="table-responsive">
                <DataTable
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  sortServer
                  dense
                />
              </div> */}

              <div>
                {/* <MaterialReactTable
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  columns={columns}
                  data={responseData}
                  enableColumnResizing
                  enableGrouping
                  sortDescFirst
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    sorting: [{ id: "state", desc: false }], //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300, 500],
                  }}
                  manualFiltering
                  manualPagination
                  manualSorting
                  // muiToolbarAlertBannerProps={
                  //   isError
                  //     ? {
                  //         color: "error",
                  //         children: "Error loading data",
                  //       }
                  //     : undefined
                  // }
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiToolbarAlertBannerProps={
                    // isError
                    // ? {
                    //   color: "error",
                    //   children: "Error loading data",
                    // }
                    // : undefined
                    {
                      isError: () => ({
                        color: "error",
                        children: "Error loading data",
                      }),
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }
                  }
                  muiSelectCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiSelectAllCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  onColumnFiltersChange={setColumnFilters}
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  state={{
                    columnFilters,
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "0.5rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={onBtExport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() =>
                          downloadPDF(
                            "",
                            "alldata",
                            table.getVisibleFlatColumns()
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                      <Button
                        // size="small"
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedrow",
                            table.getVisibleFlatColumns()
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in pdf
                      </Button>
                    </Box>
                  )}
                /> */}

<CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Manufacture Report"
                    columns={columns}
                    data={data}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                  />
              </div>
              {/* <hr /> */}
              {/* <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RepotsManufacturer;
